import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import vmdImage from "../../../assets/images/vblog1.png"; // You can update the image if needed
import ScrollToTopButton from "../../ScrollToTopButton";

const SmartDisplay = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Enhancing Communication with VMD Technology"
        breadcrumb={[
          { label: "Home", href: "/" },
          // { label: "Resources" },
          { label: "Blogs" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Enhancing Communication with VMD Technology @ GyanYantram"
          shareUrl="https://yourdomain.com/blog/vmd-technology"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8 mb-10">
            <div className="lg:w-2/3">
              <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
                Summary
              </h4>
              <p className="text-black mb-4 text-lg">
                GyanYantram’s Variable Message Displays (VMDs) offer a cutting-edge
                solution for real-time public communication. These displays can broadcast
                dynamic messages such as traffic updates, civic announcements, and emergency alerts,
                ensuring that relevant information reaches people at the right time.
              </p>
              <p className="text-black text-lg">
                VMDs enhance communication between city authorities and citizens by using
                IoT technology that allows remote content management, helping cities stay
                responsive and transparent.
              </p>
            </div>
            <div className="lg:w-1/3">
              <img src={vmdImage} alt="Smart Display VMD" className="rounded-lg" />
              <p className="text-sm text-gray-500 mt-2 italic">
                Dynamic messages shared in real-time via smart VMDs
              </p>
            </div>
          </div>

          <div className="mb-10">
            <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
              Introduction
            </h4>
            <div className="grid md:grid-cols-3 gap-6">
              <div className="md:col-span-2">
                <p className="text-black mb-4 text-lg">
                  In today’s smart cities, communication is key to operational efficiency and
                  citizen engagement. Traditional static signage is no longer enough to keep
                  up with dynamic information requirements.
                </p>
                <p className="text-black text-lg">
                  VMD technology addresses this need by enabling city administrators to push
                  real-time updates instantly across locations, ensuring timely alerts during
                  emergencies, traffic changes, and public announcements.
                </p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-[#00D084]">
                <h5 className="font-bold text-lg mb-2">Did You Know?</h5>
                <p className="text-gray-700">
                  Cities using VMDs report over 70% improvement in the effectiveness of civic
                  communication and public safety alerts.
                </p>
              </div>
            </div>
          </div>

          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-4 text-black">
              Key Features of VMD Technology:
            </h5>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-blue-500">
                  <h6 className="font-semibold text-lg mb-2">Remote Content Updates</h6>
                  <p className="text-gray-700">
                    Authorities can update VMD messages remotely from a centralized dashboard
                    in seconds.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-green-500">
                  <h6 className="font-semibold text-lg mb-2">Real-Time Alerts</h6>
                  <p className="text-gray-700">
                    Broadcast emergency information, traffic diversions, or weather alerts
                    instantly to the public.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-purple-500">
                  <h6 className="font-semibold text-lg mb-2">High Visibility Displays</h6>
                  <p className="text-gray-700">
                    Designed for high contrast and readability in all lighting and weather conditions.
                  </p>
                </div>
              </div>
              <div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-red-500">
                  <h6 className="font-semibold text-lg mb-2">Weather & Pollution Updates</h6>
                  <p className="text-gray-700">
                    VMDs can integrate with weather or air quality sensors to inform citizens
                    of current conditions.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-yellow-500">
                  <h6 className="font-semibold text-lg mb-2">Multilingual Support</h6>
                  <p className="text-gray-700">
                    Messages can be broadcast in multiple local languages to maximize reach.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-indigo-500">
                  <h6 className="font-semibold text-lg mb-2">Energy Efficient</h6>
                  <p className="text-gray-700">
                    Smart displays use LED technology for reduced power consumption and longer lifespan.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-10 bg-gray-50 p-6 rounded-lg">
            <h5 className="text-xl font-semibold mb-4 text-black text-center">
              Impact of VMDs on Urban Communication
            </h5>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl font-bold text-[#00D084] mb-2">70%</div>
                <p className="text-gray-700">Improved civic engagement</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl font-bold text-[#00D084] mb-2">50%</div>
                <p className="text-gray-700">Faster emergency response</p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow text-center">
                <div className="text-3xl font-bold text-[#00D084] mb-2">60%</div>
                <p className="text-gray-700">Better traffic flow management</p>
              </div>
            </div>
          </div>

          <div className="mb-10">
            <h5 className="text-xl font-semibold mb-3 text-black">Conclusion</h5>
            <div className="flex flex-col md:flex-row gap-6">
              <div className="md:w-2/3">
                <p className="text-black text-lg">
                  VMD technology by GyanYantram is playing a crucial role in transforming
                  public communication. With real-time, remotely managed digital signage,
                  city governance becomes more proactive, transparent, and efficient.
                </p>
              </div>
              <div className="md:w-1/3 bg-[#00D084] bg-opacity-10 p-4 rounded-lg">
                <h6 className="font-semibold text-lg mb-2">Looking Ahead</h6>
                <p className="text-gray-700">
                  Future advancements may include AI-driven message scheduling and
                  integration with mobile alerts for enhanced citizen engagement.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-lg">
            <h5 className="text-xl font-semibold mb-3 text-black">
              GyanYantram’s Contribution
            </h5>
            <div className="grid md:grid-cols-2 gap-6">
              <div>
                <p className="text-black mb-4 text-lg">
                  GyanYantram offers state-of-the-art Variable Message Displays to help
                  cities build intelligent and responsive communication systems. Their
                  VMDs support remote updates, are weather-resistant, and are designed
                  for high visibility.
                </p>
                <p className="text-black text-lg">
                  Explore more at{" "}
                  <a
                    href="https://gyanyantram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#00D084] hover:underline"
                  >
                    www.gyanyantram.com
                  </a>
                </p>
              </div>
              <div>
                <ul className="list-disc pl-6 space-y-2 text-lg text-black">
                  <li>
                    <strong>IoT-Powered Displays:</strong> Real-time data control
                  </li>
                  <li>
                    <strong>Custom Content Scheduling:</strong> Tailor messages by time or event
                  </li>
                  <li>
                    <strong>Integration Ready:</strong> Connects with sensors and emergency systems
                  </li>
                  <li>
                    <strong>Designed for Cities:</strong> Suitable for roads, public spaces, and institutions
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SmartDisplay;
